var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5777 11.9138L7.56561 17.8395C7.23053 18.1698 6.68347 18.1698 6.34745 17.8395L5.17835 16.6863C5.01544 16.5257 4.92565 16.3131 4.92565 16.0869C4.92565 15.8597 5.01544 15.6471 5.17835 15.4865L11.0859 9.66393L10.9887 9.39205C10.4518 7.90309 10.8341 6.22164 11.9634 5.10857C13.0094 4.07853 14.5432 3.68349 15.9511 4.03929L13.649 6.30831C13.3741 6.57836 13.2232 6.93874 13.2232 7.32284C13.2232 7.70603 13.3741 8.0664 13.649 8.33738L14.5848 9.25975C15.1532 9.81811 16.0761 9.81811 16.6435 9.25975L18.9456 6.99074C19.3057 8.37843 18.9058 9.89019 17.8607 10.9211C16.8147 11.9521 15.2717 12.3572 13.836 11.9813L13.5777 11.9138ZM6.95746 19C7.41473 19 7.87201 18.8276 8.22005 18.4845L13.861 12.9247C15.5364 13.2723 17.2998 12.7641 18.5152 11.5662C19.9962 10.1064 20.4165 7.85657 19.5621 5.96892L19.2881 5.36312L15.9891 8.61473C15.7826 8.81727 15.4457 8.81727 15.2393 8.61473L14.3034 7.69234C14.2035 7.59289 14.1489 7.46243 14.1489 7.32284C14.1489 7.18325 14.2035 7.05188 14.3034 6.95334L17.6025 3.70173L16.9878 3.43167C15.0717 2.58957 12.7891 3.00378 11.309 4.46263C9.99823 5.75543 9.50948 7.67227 10.0251 9.41942L4.52392 14.8415C4.18606 15.1736 4 15.6161 4 16.0869C4 16.5567 4.18606 16.9992 4.52392 17.3313L5.69302 18.4845C6.04199 18.8276 6.49927 19 6.95746 19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperator);
export default __webpack_public_path__ + "static/media/operator.cd3c1893c520d43be252f12f80670325.svg";
export { ForwardRef as ReactComponent };